import { Modal } from "@aqar-app/react-ui";
import { useAuthState } from "@/contexts/auth/auth.provider";
import LoginAlert from "../../../login-alert";
import { Icon } from "@/components/icon";
import { usePath } from "@/contexts/path/path";
import { useToggleLike } from "@/hooks/useGetUserLikes";
import { useFavListingsState } from "@/contexts/fav-listings/favListings.provider";

function LikeButton({ listing, ...props }) {
  const { token } = useAuthState();
  const { categoriesDictionary } = usePath();
  const { toggleLike, isLiked, loading } = useToggleLike(listing?.id);
  const { fetchLikesCompleted } = useFavListingsState();

  const handleToggleLike = (e) => {
    if (!token) {
      Modal.open(
        <LoginAlert text="يرجى تسجيل الدخول لإضافة الإعلان للمفضلة " />,
      )(e);
    } else {
      toggleLike(listing?.id);
    }
  };

  return (
    <button
      type="button"
      {...props}
      onClick={handleToggleLike}
      disabled={loading || !fetchLikesCompleted}
    >
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.2694 5.19858H11.512L12.5533 2.62504C12.7022 2.25838 12.7389 1.85657 12.6589 1.46947C12.5789 1.08236 12.3857 0.727001 12.1033 0.447491C11.9445 0.290589 11.753 0.169753 11.5422 0.0933762C11.3313 0.016999 11.1062 -0.0130895 10.8824 0.00520002C10.6587 0.0234895 10.4416 0.0897187 10.2463 0.199289C10.0511 0.308858 9.88225 0.459143 9.75161 0.639706L6.96971 4.48845C6.55451 5.0618 6.09278 5.60078 5.58911 6.10003L4.69811 6.98102C4.65754 7.02108 4.62537 7.06866 4.60344 7.12104C4.58151 7.17342 4.57025 7.22956 4.57031 7.28625V13.9079C4.57025 14.0226 4.61621 14.1327 4.69811 14.214L5.69621 15.2053C5.95047 15.458 6.25287 15.6584 6.58593 15.7948C6.919 15.9312 7.27611 16.0009 7.63661 16H13.06C13.4882 15.9997 13.9072 15.8767 14.2662 15.646C14.6252 15.4152 14.909 15.0866 15.0832 14.6999L17.7436 8.78125C17.9138 8.4038 18.0012 7.99497 18.0001 7.58169V6.91072C17.9996 6.45693 17.8172 6.02185 17.4927 5.70089C17.1683 5.37993 16.7284 5.19929 16.2694 5.19858Z"
          fill={isLiked ? "#52B44A" : "#666666"}
        />
        <path
          d="M1.5723 6.4017C1.1553 6.4017 0.755379 6.56549 0.460516 6.85704C0.165652 7.14859 0 7.54402 0 7.95633V13.802C0 14.2143 0.165652 14.6097 0.460516 14.9013C0.755379 15.1928 1.1553 15.3566 1.5723 15.3566C1.9893 15.3566 2.38922 15.1928 2.68408 14.9013C2.97895 14.6097 3.1446 14.2143 3.1446 13.802V7.95633C3.1446 7.54402 2.97895 7.14859 2.68408 6.85704C2.38922 6.56549 1.9893 6.4017 1.5723 6.4017Z"
          fill={isLiked ? "#52B44A" : "#666666"}
        />
      </svg>
      إعجاب
    </button>
  );
}

export default LikeButton;
